export function isPwa(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches;
}

export function isSafari(): boolean {
  const ua = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  return isSafari;
}

export function isApplePlatform() {
  const ua = navigator.userAgent;
  const platform = navigator.platform;

  if (/iPad|iPhone|iPod/.test(ua) && !(window as any)?.MSStream) {
    return 'iOS';
  }

  if (platform.toUpperCase().includes('MAC')) {
    return 'macOS';
  }

  return null;
}
